import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col } from "react-bootstrap";
import { useState } from "react";
import styles from "./App.module.css";
import ReleaseCarousel from "../../components/ReleaseCarousel/ReleaseCarousel";
import VideoCarousel from  "../../components/VideoCarousel/VideoCarousel"
import Footer from "../../components/Footer/Footer";
import { Helmet } from "react-helmet";
import FeaturedContent from "../../components/FeaturedContent/FeaturedContent";



function App() {
  const baseUrl = window.location.origin;

  const [showRelease, setShowRelease] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
      <>
      <Helmet>
        <title>alwinowitch – Offizielle Webseite</title>
        <meta
          name="description"
          content="Neue Releases, Links und Updates von alwinowitch. Offizielle Website mit Songs, Social-Media-Profilen und mehr."
        />

        <meta property="og:title" content="alwinowitch – Offizielle Webseite" />
        <meta
          property="og:description"
          content="Besuche die offizielle Website von alwinowitch mit Musik, Links und mehr."
        />
        <meta property="og:image" content={`${baseUrl}/img/alwinowitch-banner.jpg`} />
        <meta property="og:url" content={baseUrl} />
        <meta property="og:type" content="website" />

        {/* JSON-LD für Person */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Person",
            "name": "alwinowitch",
            "url": baseUrl,
            "image": `${baseUrl}/img/alwinowitch-banner.jpg`,
            "sameAs": [
              "https://www.youtube.com/channel/UCQN9zbCfTgRbYaUjI_lJlvA",
              "https://soundcloud.com/alwinowitch",
              "https://open.spotify.com/intl-de/artist/3bUiiFAMU2mzToyw0ADEdj?si=573cc289b4534367",
              "https://music.apple.com/de/artist/alwinowitch/1737302812",
              "https://www.instagram.com/alwin_mc_burger/",
              "https://www.tiktok.com/@alwin_mc_burger",
              "https://music.youtube.com/channel/UCzoIhrVkr6nWUTphVcjpz4A"
            ],
            "jobTitle": "Musiker",
            "description":
              "Neue Releases, Links und Updates von alwinowitch. Offizielle Website mit Songs, Social-Media-Profilen und mehr."
          })}
        </script>
      </Helmet>
        
      {/* Navbar */}
      <div className="navbar fixed-top px-4 py-3 d-flex justify-content-between align-items-center bg-transparent">
        <img src="img/alwinowitch-logo.png" alt="Logo" className={styles.logo} />
        {/* Hamburger Button für Mobile */}
        <button
          className="btn d-md-none"
          style={{ color: "var(--home-font-color-primary)" }}
          onClick={() => setMenuOpen(true)}
        >
          <i className="bi bi-list" style={{ fontSize: "2rem" }}></i>
        </button>
        {/* Normale Links nur am Desktop */}
        <div className={`${styles.navLinks} d-none d-md-flex gap-4`}>
          {showRelease && (
            <a href="#releases" className="text-decoration-none">RELEASES</a>
          )}
          <a href="#featured" className="text-decoration-none">FEATURED</a>
          {showVideo && (
            <a href="#videos" className="text-decoration-none">VIDEOS</a>
          )}
        </div>
      </div>
        
      {/* Fullscreen Overlay Menu */}
      {menuOpen && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column"
          style={{
            backgroundColor: "rgba(var(--home-bg-color-rgb), 0.8)",
            zIndex: 3000,
          }}
        >
          {/* Header mit Logo + Close */}
          <div className="d-flex justify-content-between align-items-center p-4">
            <img src="img/alwinowitch-logo.png" alt="Logo" className={styles.logo} />
            <button className="btn" style={{ color: "var(--home-font-color-primary)" }} onClick={() => setMenuOpen(false)}>
              <i className="bi bi-x" style={{ fontSize: "4rem" }}></i>
            </button>
          </div>
        
          {/* Links */}
          <div className={`${styles.navLinks} d-flex flex-column align-items-center gap-4 mt-5`}>
            {showRelease && (
              <a
                href="#releases"
                className="text-decoration-none"
                onClick={() => setMenuOpen(false)}
              >
                RELEASES
              </a>
            )}
            <a
              href="#featured"
              className="text-decoration-none"
              onClick={() => setMenuOpen(false)}
            >
              FEATURED
            </a>
            {showVideo && (
              <a
                href="#videos"
                className="text-decoration-none"
                onClick={() => setMenuOpen(false)}
              >
                VIDEOS
              </a>
            )}
          </div>
        </div>
      )}


      

      <div
        className={styles.backgroundImage}
        style={{
          height: "100vh",
          background: `linear-gradient(
            to bottom,
            rgba(var(--home-bg-color-rgb), 0) 85%,
            rgba(var(--home-bg-color-rgb), 1) 100%
          ), url(${process.env.PUBLIC_URL}/img/alwinowitch-background.jpeg) center 80%/cover no-repeat`
        }}
      >
        
        {/* Künstlername */}
        <div className={styles.centerContent}>
        <h1 className={styles.artistName}>alwinowitch</h1>

        {/* Social Icons */}
        <div className={`${styles.socialIcons} mt-3`}>
          <a className={styles.socialIcon} href="https://www.youtube.com/channel/UCQN9zbCfTgRbYaUjI_lJlvA" target="_blank" rel="noopener noreferrer"><i className="bi bi-youtube"></i></a>
          <a className={styles.socialIcon} href="https://soundcloud.com/alwinowitch" target="_blank" rel="noopener noreferrer"><i className="bi bi-soundcloud"></i></a>
          <a className={styles.socialIcon} href="https://open.spotify.com/intl-de/artist/3bUiiFAMU2mzToyw0ADEdj?si=573cc289b4534367" target="_blank" rel="noopener noreferrer"><i className="bi bi-spotify"></i></a>
          <a className={styles.socialIcon} href="https://music.apple.com/de/artist/alwinowitch/1737302812" target="_blank" rel="noopener noreferrer"><i className="bi bi-apple"></i></a>
          <a className={styles.socialIcon} href="https://www.instagram.com/alwinowitch/" target="_blank" rel="noopener noreferrer"><i className="bi bi-instagram"></i></a>
          <a className={styles.socialIcon} href="https://www.tiktok.com/@alwin_mc_burger" target="_blank" rel="noopener noreferrer"><i className="bi bi-tiktok"></i></a>
        </div>
        </div>
      </div>
        
        <ReleaseCarousel onConditionChange={setShowRelease} />
        <FeaturedContent />
        <VideoCarousel onConditionChange={setShowVideo} />
      <Footer bgColor="var(--home-bg-color)" fontColor="var(--home-font-color-primary)"/>
    </>
  );
}

export default App;
